import {getPathWithPrefix} from 'utils/helper'
import {
  ANALYTICS_PATH,
  ASSETS_PATH,
  CLIENT_PORTAL_PATH,
  KNOWLEDGEBASE_PATH,
  SETTINGS_PATH,
  STATUS_PAGE_PATH,
} from './path'

export const BREAD_CRUMBS = [
  {path: '/home', name: 'Home'},
  {path: '/inbox', name: 'Inbox'},
  {path: '/customers/*', name: 'Customers'},
  {path: 'setting/customers', name: 'Customers'},
  {
    path: '/customers/:id',
    name: 'Customer details',
    isDynamic: true,
    key: 'customerName',
  },
  {path: '/analytics/*', name: 'Analytics'},
  {path: '/tasks', name: 'Tasks'},
  {path: '/getting-started', name: 'Getting Started'},
  {path: `/${SETTINGS_PATH.PREFIX}/*`, name: 'Settings'},
  {path: getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.MY_PROFILE), name: 'My Profile'},
  {path: getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.ACCOUNT_SETTINGS), name: 'Account Settings'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.EMAIL}/*`, name: 'Email'},
  {
    path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.EMAIL}/:id`,
    name: 'Email Details',
    isDynamic: true,
    key: 'inboxName',
  },
  {path: getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.NOTIFICATIONS), name: 'Notifications'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.TEAMS}/*`, name: 'Teams'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.TEAMS}/:id`, name: 'Team Details'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.ROLES}/*`, name: 'Roles'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.ROLES}/:roleId`, name: 'Role Details'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.SMS}/*`, name: 'SMS'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.SMS}/:inboxId`, name: 'SMS Details'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.CUSTOMERS}`, name: 'Contact Filed'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.ROUTING}/*`, name: 'Routing'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.ROUTING}/:id`, name: 'Routing Details'},
  {path: getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.TIME_TRACKING), name: 'Time Tracking'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.INTEGRATIONS}/*`, name: 'Integrations'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.BUSINESS_HOURS}/*`, name: 'Business Hours'},
  {
    path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.BUSINESS_HOURS}/:id`,
    name: 'Business Hours details',
    isDynamic: true,
    key: 'bhName',
  },
  {path: `${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.USERS}/*`, name: 'Users'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.USERS}/:id`, name: 'User details'},
  {path: getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.SUPPORT_WIDGET), name: 'Widget'},
  {path: getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.LIVE_CHAT), name: 'Chat'},
  {path: getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.PHONE), name: 'Phone'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.FACEBOOK}/*`, name: 'Facebook'},
  {
    path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.FACEBOOK}/:id`,
    name: 'Facebook details',
    isDynamic: true,
    key: 'fbName',
  },
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.INSTAGRAM}/*`, name: 'Instagram'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.WHATSAPP}/*`, name: 'Whatsapp'},
  {
    path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.TWITTER}/:id`,
    name: 'Twitter details',
    isDynamic: true,
    key: 'twitterName',
  },
  {path: getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.TWITTER), name: 'Twitter'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.CONTACT_FORM}/*`, name: 'Contact Form'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.CONTACT_FORM}/:id`, name: 'Contact Form Details'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.WORKFLOWS}/*`, name: 'Workflows'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.WORKFLOWS}/:id`, name: 'Workflow Details'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.EMAIL_TEMPLATES}/*`, name: 'Email Templates'},
  {
    path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.EMAIL_TEMPLATES}/:id`,
    name: 'Email Templates details',
    isDynamic: true,
    key: 'emailTmptName',
  },
  {path: getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.TAGS), name: 'Tags'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.SLA_MANAGEMENT}/*`, name: 'SLA Management'},
  {
    path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.SLA_MANAGEMENT}/:id`,
    name: 'SLA Management details',
    isDynamic: true,
    key: 'SlaName',
  },
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.CUSTOMER_SATISFACTION}/*`, name: 'Customer Satisfaction'},
  {
    path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.CUSTOMER_SATISFACTION}/:id`,
    name: 'Customer Satisfaction details',
    isDynamic: true,
    key: 'CSName',
  },
  {path: getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.AUDIT_LOGS), name: 'Audit Logs'},
  {path: getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.MY_PLAN), name: 'My Plan'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.INVOICES}/*`, name: 'Invoices'},
  {
    path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.INVOICES}/:invoiceId`,
    name: 'Invoice Details',
    isDynamic: true,
    key: 'invoiceName',
  },
  {path: getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.DEVELOPER_API), name: 'Developer API'},
  {path: `/${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.KEYBOARD_SHORTCUTS}`, name: 'Keyboard Shortcuts'},

  // status page
  {path: `/${STATUS_PAGE_PATH.PREFIX}/*`, name: 'Status Page'},
  {path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.INCIDENTS), name: 'Incidents'},
  {path: `/${STATUS_PAGE_PATH.PREFIX}/${STATUS_PAGE_PATH.INCIDENTS}/:incidentsId`, name: 'Incidents'},
  {path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.MAINTENANCE), name: 'Maintenance'},
  {path: `/${STATUS_PAGE_PATH.PREFIX}/${STATUS_PAGE_PATH.MAINTENANCE}/:maintenanceId`, name: 'Maintenance'},
  {
    path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.SERVICE_COMPONENTS),
    name: 'Service Components',
  },
  {
    path: `/${STATUS_PAGE_PATH.PREFIX}/${STATUS_PAGE_PATH.SERVICE_COMPONENTS}/:id/service`,
    name: 'Service Components',
  },
  {
    path: `/${STATUS_PAGE_PATH.PREFIX}/${STATUS_PAGE_PATH.SERVICE_COMPONENTS}/:id/group`,
    name: 'Service Components',
  },
  {
    path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.MANAGE_SUBSCRIBERS),
    name: 'Manage Subscribers',
  },
  {path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.CUSTOMIZATION), name: 'Customization'},
  {path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.GENERAL), name: 'General'},
  {path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.STATUS_EMBED), name: 'Status Embed'},
  {path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.TEMPLATES), name: 'Templates'},
  {
    path: `/${STATUS_PAGE_PATH.PREFIX}/${STATUS_PAGE_PATH.TEMPLATES}/:id`,
    name: 'Templates',
  },
  {path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.INCIDENT_SOURCES), name: 'Incident Source'},
  {path: getPathWithPrefix(STATUS_PAGE_PATH.PREFIX, STATUS_PAGE_PATH.INCIDENT_STATUS), name: 'Incident Status'},

  {path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.OVERVIEW), name: 'Overview'},
  {path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.INBOX), name: 'Inbox'},
  {path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.TAGS), name: 'Tags'},
  {
    path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.CUSTOMER_SATISFACTION),
    name: 'Customer Satisfaction',
  },
  {path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.METRICS), name: 'Metrics'},
  {path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.USERS), name: 'Users'},
  {path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.STAFFING_PREDICTION), name: 'Staffing Prediction'},
  {path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.SLA), name: 'SLA'},
  {path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.ARTICLES), name: 'Articles'},
  {path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.SEARCHES), name: 'Searches'},
  {path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.TASKS_ANALYTICS), name: 'Tasks Analytics'},
  {path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.ASSETS_ANALYTICS), name: 'Assets Analytics'},
  {path: getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.STATUS_PAGE), name: 'Status Page'},
  {path: `/${ASSETS_PATH.PREFIX}/*`, name: 'Assets'},
  {path: getPathWithPrefix(ASSETS_PATH.PREFIX, ASSETS_PATH.ALL), name: 'All'},
  {path: getPathWithPrefix(ASSETS_PATH.PREFIX, ASSETS_PATH.DEFAULT), name: 'Default'},
  {path: getPathWithPrefix(ASSETS_PATH.PREFIX, ASSETS_PATH.FIELDS), name: 'Fields'},
  {path: getPathWithPrefix(ASSETS_PATH.PREFIX, ASSETS_PATH.IMPORT), name: 'Import'},
  {path: `/${KNOWLEDGEBASE_PATH.PREFIX}/*`, name: 'Knowledge Base'},
  {
    path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/*`,
    name: 'Home',
    isDynamic: true,
    key: 'kbName',
  },
  {
    path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.ARTICLES}/*`,
    name: 'Articles',
  },
  {
    path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.ARTICLES}/:articleId`,
    name: 'Articles Details',
    isDynamic: true,
    key: 'articleName',
  },
  {
    path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.ARTICLES}/:articleId/${KNOWLEDGEBASE_PATH.VERSION_CONTROL}/:verionIds`,
    name: 'Version Control',
  },
  {path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.CATEGORIES}/*`, name: 'Categories'},
  {path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.CUSTOMIZATION}`, name: 'Customization'},
  {path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.GENERAL}`, name: 'General Settings'},
  {path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.ADVANCED}`, name: 'Advance Settings'},
  {path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.SEO}`, name: 'SEO Settings'},
  {
    path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.VERSION_CONTROL}`,
    name: 'Version Control',
  },
  {
    path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.BACKUP_AND_RESTORE}`,
    name: 'Backup & Restore',
  },
  {
    path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.CUSTOM_CSS_JS}`,
    name: 'Custom CSS & JS',
  },
  {
    path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.REDIRECT_RULES}`,
    name: 'Redirect Rules',
  },
  {path: `/${KNOWLEDGEBASE_PATH.PREFIX}/:id/${KNOWLEDGEBASE_PATH.IMPORT_EXPORT}`, name: 'Import'},
  {path: `${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.TASK_TEMPLATES}/*`, name: 'Task Template'},
  {path: `${SETTINGS_PATH.PREFIX}/${SETTINGS_PATH.TASK_AUTOMATION}/*`, name: 'Task Automation'},
  {path: `/${CLIENT_PORTAL_PATH.PREFIX}/*`, name: 'Client Portal'},
  {path: getPathWithPrefix(CLIENT_PORTAL_PATH.PREFIX, CLIENT_PORTAL_PATH.ANNOUNCEMENTS), name: 'Announcements'},
  {path: getPathWithPrefix(CLIENT_PORTAL_PATH.PREFIX, CLIENT_PORTAL_PATH.CUSTOMIZATION), name: 'Customization'},
  {path: getPathWithPrefix(CLIENT_PORTAL_PATH.PREFIX, CLIENT_PORTAL_PATH.GENERAL), name: 'General'},
  {path: getPathWithPrefix(CLIENT_PORTAL_PATH.PREFIX, CLIENT_PORTAL_PATH.TICKETS), name: 'Tickets'},
]
